import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import Features from './components/Features';
import Courses from './components/Courses';
import Certification from './components/Certification';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Gallery from './components/Gallery';
import SEOHead from '../../components/base/SEOHead';

export default function Home() {
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": `${import.meta.env.VITE_SITE_URL || ''}/#organization`,
        "name": "AULA K9 - Don Bandi El Taller de Pensar",
        "url": import.meta.env.VITE_SITE_URL || '',
        "logo": {
          "@type": "ImageObject",
          "url": "https://static.readdy.ai/image/1641cce445e23a33732a9af05560332a/70e0a6262e82dd81bec3e04351468183.png"
        },
        "description": "Centro de formación profesional en adiestramiento canino en Navarra adaptada al INCUAL. Excelencia en formación colaborativa con metodología paso a paso.",
        "address": {
          "@type": "PostalAddress",
          "addressRegion": "Navarra",
          "addressLocality": "Pamplona",
          "addressCountry": "ES"
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+34-722-131-257",
          "contactType": "customer service",
          "email": "info@aulak9.org",
          "availableLanguage": "Spanish"
        },
        "sameAs": []
      },
      {
        "@type": "WebSite",
        "@id": `${import.meta.env.VITE_SITE_URL || ''}/#website`,
        "url": import.meta.env.VITE_SITE_URL || '',
        "name": "AULA K9 - Don Bandi El Taller de Pensar",
        "description": "Formación profesional en adiestramiento canino en Navarra adaptada al INCUAL",
        "publisher": {
          "@id": `${import.meta.env.VITE_SITE_URL || ''}/#organization`
        },
        "inLanguage": "es-ES"
      },
      {
        "@type": "WebPage",
        "@id": `${import.meta.env.VITE_SITE_URL || ''}/#webpage`,
        "url": import.meta.env.VITE_SITE_URL || '',
        "name": "AULA K9 Don Bandi Adiestramiento Canino Navarra | Formación Profesional INCUAL",
        "isPartOf": {
          "@id": `${import.meta.env.VITE_SITE_URL || ''}/#website`
        },
        "about": {
          "@id": `${import.meta.env.VITE_SITE_URL || ''}/#organization`
        },
        "description": "AULA K9 Don Bandi El Taller de Pensar ofrece formación profesional en adiestramiento canino en Navarra adaptada al INCUAL. Cursos online de educación canina, modificación de conductas, primeros auxilios y técnicas de aprendizaje.",
        "inLanguage": "es-ES"
      },
      {
        "@type": "EducationalOrganization",
        "@id": `${import.meta.env.VITE_SITE_URL || ''}/#educationalorg`,
        "name": "AULA K9 - Don Bandi El Taller de Pensar",
        "url": import.meta.env.VITE_SITE_URL || '',
        "description": "Centro de formación profesional especializado en adiestramiento canino en Navarra con certificación oficial según RD 545/2023",
        "address": {
          "@type": "PostalAddress",
          "addressRegion": "Navarra",
          "addressLocality": "Pamplona",
          "addressCountry": "ES"
        },
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Cursos de Adiestramiento Canino",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Course",
                "name": "Adiestramiento con técnicas de aprendizaje",
                "courseCode": "ECP1741_2"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Course",
                "name": "Modificación de conductas no deseadas",
                "courseCode": "ECP1742_2"
              }
            }
          ]
        }
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="AULA K9 Don Bandi Adiestramiento Canino Navarra | Formación Profesional INCUAL"
        description="AULA K9 Don Bandi El Taller de Pensar — Formación profesional en adiestramiento canino en Navarra adaptada al INCUAL. Cursos online de educación canina, modificación de conductas y primeros auxilios. Metodología paso a paso con certificación oficial."
        keywords="adiestramiento canino Navarra, AULA K9, Don Bandi, formación INCUAL, educación canina online"
        canonical="/"
        schema={schema}
      />
      <Header />
      <main>
        <Hero />
        <Features />
        <Courses />
        <Certification />
        <Testimonials />
        <CTA />
        <Gallery />
      </main>
      <Footer />
    </div>
  );
}
